import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = { src: String, name: String }

    add(event) {
        event.preventDefault();
        const src  = this.srcValue;
        const name = this.nameValue || "sticker";
        if (!src) return;
        // Tell the editor to add it (editor listens globally)
        document.dispatchEvent(new CustomEvent("ie:addSticker", {
            detail: { src, name }
        }));
    }
}